import { ApiError } from '../errors/api-error.js';

export class TailorabilityService {
    constructor(api) {
        this.api = api;
    }

    async _wrap(fn, fb, okMsg) {
        try {
            const r = await fn();
            return { success: true, data: r?.data ?? r, message: r?.message || okMsg };
        }
        catch (e) {
            if (e instanceof ApiError) throw e;
            if (e.statusCode || e.status) throw ApiError.fromResponse(e);
            throw new ApiError(e.message || fb, 500, 'UNKNOWN_ERROR', e);
        }
    }

    async listCustomFields() { return this._wrap(() => this.api.listCustomFields(), 'Failed to list custom fields'); }
    async getCustomFieldById(id) { return this._wrap(() => this.api.getCustomFieldById(id), 'Failed to load custom field'); }
    async createCustomField(body) { return this._wrap(() => this.api.createCustomField(body), 'Failed to create', 'Kayıt oluşturuldu'); }
    async updateCustomField(id, body) { return this._wrap(() => this.api.updateCustomField(id, body), 'Failed to update', 'Kayıt güncellendi'); }
    async deleteCustomField(id) { return this._wrap(() => this.api.deleteCustomField(id), 'Failed to delete', 'Kayıt silindi'); }
    async customFieldsByEntity(entityType) { return this._wrap(() => this.api.customFieldsByEntity(entityType), 'Failed to load'); }

    async listFormLayouts() { return this._wrap(() => this.api.listFormLayouts(), 'Failed to list layouts'); }
    async getFormLayoutById(id) { return this._wrap(() => this.api.getFormLayoutById(id), 'Failed to load layout'); }
    async createFormLayout(body) { return this._wrap(() => this.api.createFormLayout(body), 'Failed to create', 'Kayıt oluşturuldu'); }
    async updateFormLayout(id, body) { return this._wrap(() => this.api.updateFormLayout(id, body), 'Failed to update', 'Kayıt güncellendi'); }
    async deleteFormLayout(id) { return this._wrap(() => this.api.deleteFormLayout(id), 'Failed to delete', 'Kayıt silindi'); }
    async formLayoutsByEntity(entityType, params = {}) {
        return this._wrap(() => this.api.formLayoutsByEntity(entityType, params), 'Failed to load');
    }

    async listCustomPermissions() { return this._wrap(() => this.api.listCustomPermissions(), 'Failed to list permissions'); }
    async getCustomPermissionById(id) { return this._wrap(() => this.api.getCustomPermissionById(id), 'Failed to load permission'); }
    async createCustomPermission(body) { return this._wrap(() => this.api.createCustomPermission(body), 'Failed to create', 'Kayıt oluşturuldu'); }
    async updateCustomPermission(id, body) { return this._wrap(() => this.api.updateCustomPermission(id, body), 'Failed to update', 'Kayıt güncellendi'); }
    async deleteCustomPermission(id) { return this._wrap(() => this.api.deleteCustomPermission(id), 'Failed to delete', 'Kayıt silindi'); }

    async getBranding() { return this._wrap(() => this.api.getBranding(), 'Failed to load branding'); }
    async upsertBranding(body) { return this._wrap(() => this.api.upsertBranding(body), 'Failed to save', 'Branding kaydedildi'); }
    async listFeatureFlags() { return this._wrap(() => this.api.listFeatureFlags(), 'Failed to list flags'); }
    async upsertFeatureFlag(body) { return this._wrap(() => this.api.upsertFeatureFlag(body), 'Failed to save flag', 'Bayrak güncellendi'); }
}
